module.exports = __webpack_public_path__ + "assets/media/brian_moseley_face.69884908.png";